import React from 'react';
import { CgAsterisk } from 'react-icons/cg';
import { ReactComponent as RequestsIcon } from '../../../../resource/RequestsIcon.svg';
import { ReactComponent as DocumentsIcon } from '../../../../resource/DocumentsIcon.svg';
import { ReactComponent as QuestionsIcon } from '../../../../resource/QuestionsIcon.svg';
import { ReactComponent as ShutdownsIcon } from '../../../../resource/ShutdownsIcon.svg';
import { ReactComponent as InformationsIcon } from '../../../../resource/InformationsIcon.svg';
import { ReactComponent as VotingIcon } from '../../../../resource/VotingIcon.svg';

export const notificationsConfig = {
  all: {
    name: 'all',
    icon: CgAsterisk,
    tooltip: 'Все',
  },

  REQUEST: {
    name: 'REQUEST',
    route: '/Requests',
    icon: RequestsIcon,
    tooltip: 'Заявки',
    fallbackText: `Заявка недоступна в связи с изменением параметров`,
  },

  DOCUMENT: {
    name: 'DOCUMENT',
    route: '/Documents',
    icon: DocumentsIcon,
    tooltip: 'Документы',
    fallbackText: `Документ недоступен в связи с изменением параметров`,
  },

  QUESTION: {
    name: 'QUESTION',
    route: '/Questions',
    icon: QuestionsIcon,
    tooltip: 'Вопросы',
    fallbackText: `Вопрос недоступен в связи с изменением параметров`,
  },

  INFO: {
    name: 'INFO',
    route: '/Informations',
    icon: InformationsIcon,
    tooltip: 'Информирование',
    fallbackText: `Информирование недоступно в связи с изменением параметров`,
  },

  VOTING: {
    name: 'VOTING',
    route: '/Voting',
    icon: VotingIcon,
    tooltip: 'Опросы',
    fallbackText: `Опрос недоступен в связи с изменением параметров`,
  },

  ALERT: {
    name: 'ALERT',
    route: '/Shutdowns',
    icon: ShutdownsIcon,
    tooltip: 'Отключения',
    fallbackText: `Отключение недоступно в связи с изменением параметров`,
  },
};

export const notificationsQueryParams = { showAll: true, onlyForWeb: true };
